// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilitySecondaryInsurance {
    static getAttributeTypeMap() {
        return MedicalEligibilitySecondaryInsurance.attributeTypeMap;
    }
}
MedicalEligibilitySecondaryInsurance.discriminator = undefined;
MedicalEligibilitySecondaryInsurance.additionalProperties = false;
MedicalEligibilitySecondaryInsurance.attributeTypeMap = [
    {
        "name": "exists",
        "baseName": "exists",
        "type": "boolean"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilitySecondaryInsurance.js.map